import React from 'react'

const FuncComp = () => {
  return (
    <div>This is a Functional Component!</div>
  )
}

export default FuncComp;